import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { queryClient } from 'constants/query-client';
import { ApiError, ApiResponse } from 'types/utils/api-response';
import { PurchaseHistory } from './useGetPaymentHistory';

export const useGetPurchaseHistoryRefresh = (
  options: Partial<
    UseMutationOptions<PurchaseHistory[], AxiosError<ApiError>>
  > = {}
) =>
  useMutation({
    mutationFn: async () => {
      const { data } = await api.post<ApiResponse<PurchaseHistory[]>>(
        `/purchase/history/refresh`
      );

      return data.data;
    },
    mutationKey: ['purchase/history/refresh'],
    onSuccess: (response) => {
      queryClient.setQueryData(['purchase/history'], () => response);
    },

    ...options,
  });
